/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./alertConfigs.vue?vue&type=template&id=68edcfd1&scoped=true&"
import script from "./alertConfigs.vue?vue&type=script&lang=js&"
export * from "./alertConfigs.vue?vue&type=script&lang=js&"
import style0 from "./alertConfigs.vue?vue&type=style&index=0&id=68edcfd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68edcfd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VForm,VRow,VSkeletonLoader})
